export const geoLockingEnabled = String(process.env.GATSBY_GEO_LOCKING_ENABLED).toLowerCase() === "true"

// Must match the API's PAPERING_MIN_TICKETS, which enforces it
export const paperingMinTickets = Math.max(1, parseInt(process.env.GATSBY_PAPERING_MIN_TICKETS, 10) || 1)
